import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { mcpOauthSaveUrl, resolveMcpAuth } from './mcp-auth';
import { submitLogToBugsnag } from '../log';

export default async function save_mcp_oauth_api_call(
  mcpId: number,
  oauthCode: string,
  is_onboarding?: boolean
) {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const auth = resolveMcpAuth();

    const sendingData: any = {
      tara_mcp_id: mcpId,
      oauth_code: oauthCode,
    };

    if (is_onboarding) {
      sendingData.redirect_path = '/onboarding';
    }

    const requestInfo: RequestInfo = {
      url: mcpOauthSaveUrl(auth, shopSlug),
      method: 'POST',
      body: JSON.stringify(sendingData),
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        Authorization: auth.authorization,
      },
    };

    const actionType = 'SAVE_MCP_OAUTH';
    const customMsg = 'MCP OAuth saved successfully.';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      false,
      false,
      false,
      false
    );

    const response = res.data;

    if (res.actionType === actionType) {
      return response;
    } else {
      return {};
    }
  } catch (exception) {
    console.log('Error during authentication request');
    submitLogToBugsnag('error', `${exception}`);
    return false;
  }
}
